// jshint ignore: start

export default {
  email_suggestion: {
    prefix: '您是不是要输入',
    suffix: '？',
    accept_label: '将邮箱更改为 {{email}}',
  },
  auth_modal: {
    aria_label: {
      login: '登录 CGTrader',
      signup: '注册 CGTrader',
    },
    header: {
      login_title: '欢迎回来',
      signup_title: '创建您的账户',
      login_subtitle: '登录以继续创作、设计和下载。',
    },
    social_divider: '或使用邮箱',
    email_label: '邮箱',
    email_placeholder: 'john@email.com',
    email_aria_label: '邮箱地址',
    opt_in_label: '获取产品更新、社区新闻和优惠信息。',
    submit_button: '使用邮箱继续',
    switch: {
      already_member: '已是会员？',
      log_in: '登录',
      new_here: '新用户？',
      create_account: '创建账户',
    },
    terms: {
      prefix: '继续即表示我同意',
      terms_link: '通用条款与条件',
      middle: '和',
      privacy_link: '隐私政策',
      suffix: '。',
    },
    code: {
      title: '请查收您的邮箱',
      subtitle_prefix: '我们已将6位验证码发送至',
      subtitle_suffix: '',
      email_fallback: '您的邮箱',
      digit_aria_label: '第{{number}}位',
      error: '访问码无效。请重试。',
      resend_prompt: '没有收到？',
      resend_link: '重新发送验证码',
      resend_countdown: '{{time}} 后可重新发送验证码',
      change_email_link: '更换邮箱',
    },
    success: {
      login_title: '欢迎回来',
      signup_title: '注册成功',
      signed_in_prefix: '已登录为',
      signed_in_suffix: '',
      signup_subtitle: '账户已创建。一起找到您的下一个模型吧。',
    },
    password: {
      link: '改用密码登录',
      email_label: '邮箱或用户名',
      title: '使用密码登录',
      subtitle: '请输入您的邮箱和密码以继续。',
      password_label: '密码',
      forgot_password: '忘记密码？',
      submit_button: '登录',
      back: '返回',
      show_password: '显示密码',
      hide_password: '隐藏密码',
      error_generic: '出了点问题。请稍后再试。',
      required_notice: '请同时输入您的密码以完成 2FA。',
      two_fa_code_label: '验证码',
    },
  },
  login: {
    generic_auth_error: '出现错误。请稍后再试。',
  },
  itemPage: {
    licenseDropdown: {
      aiContactNote: {
        question: '需要 AI 兼容的许可证吗？',
        linkText: '请联系我们的销售团队了解企业数据许可选项。',
      },
    },
    units: {
      mm: '毫米',
      cm: '厘米',
      in: '英寸',
      m: '米',
    },
    supportForm: {
      messageSent: '消息已成功发送',
    },
  },
  listingPage: {
    pagination: {
      label: '分页',
      firstPage: '转到第一页',
      previousPage: '转到上一页',
      nextPage: '转到下一页',
      lastPage: '转到最后一页',
      page: '第 {{number}} 页',
    },
    filters: {
      allFilters: '所有筛选器',
      resetFilters: '清除',
      lastUsed: '最近',
      fileFormat: '文件格式',
      searchPlaceholder: '输入以搜索',
      price: {
        freeOnly: '仅限免费',
        onSale: '特卖（最高{{percentage}}%折扣）',
      },
      customPriceRange: '自定义价格范围',
      quickSelections: '快速选择',
      subscriptionTier: {
        label: '订阅',
        all: '全部',
        yourPlan: '您的方案',
      },
      pricePlaceholder: '价格',
      polyCountRange: '自定义多边形数量范围',
      cardSize: '卡片大小',
      cardVisibility: '可见性设置',
      visibility: {
        format: '格式',
        price: '价格',
        cgtStandard: 'CGT标准',
        type: '类型',
        title: '标题',
        quickActionsOnHover: '悬停时的快捷操作',
        suggestions: '建议',
      },
      items: '个项目',
      perPage: '每页：',
      wishListOnly: '仅显示愿望清单',
      hideOwnedModels: '隐藏拥有的模型',
      ownedModels: '仅显示已购买模型',
      sortBy: {
        default: '默认',
        label: '排序',
      },
      remaining: {
        label: '筛选',
      },
      showMoreButtonText: '显示更多',
    },
    suggestedSearch: {
      showingResultsFor: '显示结果',
      ifYouMeant: '如果您想搜索',
      tryThatSearchInstead: '请尝试该搜索',
    },
    gallery: {
      formats: '格式',
      geometry: '几何体',
      type: '类型',
      details: '详情',
      unknown: '未知',
      polygons: '{{value}} 个多边形',
      vertices: '{{value}} 个顶点',
      previewing: '预览中',
      types: {
        print_ready: '3D 打印',
        pbr: 'PBR',
        animated: '动画',
        rigged: '已绑定',
        low_poly: '低多边形',
      },
      attributes: {
        textures: '贴图',
        materials: '材质',
        uvw_mapping: 'UV 贴图',
        plugins_used: '使用的插件',
      },
    },
    actions: {
      preview: '预览',
      see_similar_models: '查看相似模型',
      add_to_cart: '加入购物车',
      remove_from_cart: '从购物车移除',
      add_to_wishlist: '加入心愿单',
      remove_from_wishlist: '从心愿单移除',
      purchased: '已购买',
      open: '打开',
    },
    download: {
      tooltip: '下载',
      header: '下载文件',
      loading: '正在加载文件...',
      empty: '没有可下载的文件。',
    },
    upsellBlock: {
      label: '特别优惠',
      heading: '以更低的价格下载更多模型',
      body: '每月25个模型，$9.99 起',
      cta: '获取订阅',
    },
    footerBanners: {
      title: '找不到您要找的东西？',
      hire3dFreelancerBanner: {
        title: '雇佣3D自由职业者',
        description: '您将有机会直接与经验丰富的3D设计师合作，开展包括3D打印和动画在内的各种定制项目。',
        description2: '只需提交项目描述，即可收到不同设计师的报价，从而选择最合适的一个。',
        learnMoreButtonText: '了解更多',
        learnMoreButtonUrl: '/zh-CN/3d-modeling-jobs',
        postAProjectButtonText: '发布项目',
      },
      searchSubscription: {
        title: '订阅此搜索',
        description: '我们会记住您的搜索设置，并在有新结果时通知您。',
        subscribe: '订阅',
        subscribing: '订阅中...',
        inputPlaceholder: '请详细描述您的搜索，以帮助我们大幅改进3D模型库。',
      },
    },
  },
  browser: {
    filters: {
      cgt_standard_only: 'CGT标准',
      cgt_standard_tooltip_title: 'CGT标准 - 可直接导入，无需清理。',
      cgt_standard_tooltip_body: '自动检查几何体、UV、纹理、场景设置和命名 - 可在Blender、Maya、Unreal Engine、Unity及其他主流工具中使用。自动验证 - 非卖家自行声明。',
    },
  },
  printModelPage: {
    sectionTitle: '3D打印',
    heroTitle: '探索3D打印模型',
    sectionDescription: '高质量的3D打印模型、文件和资源，适用于家用或专业FDM、SLA或SLS 3D打印机。',
    placeholderText: '搜索超过80万个3D打印模型',
    allCategories: '浏览所有模型',
    categorySectionTitle: "适用于各种创意的3D打印文件",
    categorySectionDescription: "浏览为FDM、SLA或树脂3D打印设计的高质量3D文件。为任何项目找到合适的3D打印模型。",
    categorySectionButtonText: "浏览所有文件",
    categorySectionBadgeText: "分类",
    budgetSectionTitle: "探索适合您预算的模型",
    budgetSectionDescription: "发现高性价比模型，兼顾品质",
    BrowseAllText: '浏览全部 '
  },
  projects: {
    newestFirst: 'Newest first',
    highestBudget: 'Highest budget',
    fewestApplicants: 'Fewest applicants',
    modelingJob: '3d modeling job',
    myProjects: 'My 3D Projects',
    projects: '3D Projects',
    reviewProjectApplication: 'Review 3D Project application',
    startAProject: 'Start a Project',
    editProject: 'Edit Project',
    reviewProject: 'Review Project',
    applyToProject: 'Apply to 3D Project',
    editProjectApplication: 'Edit 3D Project application',
    learnMoreHowItWorks: 'Learn more how it works',
    projectsDashboard: 'Projects dashboard',
    cgtraderModelingJob: 'CGTrader 3D Modeling Jobs',
    software: '3D Software',
    skills: '3D Skills',
    searchPlaceholder: 'Search'
  },
  subscription_management: {
    empty_state: {
      message: '您没有有效的订阅',
      view_essentials: '查看 Essentials',
      view_essentials_premium: '查看 Essentials 和 Premium 计划',
    },
    active: {
      plan_name: {
        essentials: 'CGTrader Essentials',
        premium: 'CGTrader Premium',
        ai_studio: 'CGTrader AI',
      },
      badge_cancelled: '已取消',
      cancel_button: '取消订阅',
      renew_button: '续订',
      reactivate_button: '重新激活订阅',
      annual_plan: '年度计划',
      monthly_plan: '月度计划',
      renewal_message_prefix: '您的订阅将于',
      renewal_message_suffix: '自动续订',
      monthly_renewal_message: '您的订阅按月续订',
      monthly_renewal_message_ai: '每月续订，下次为 {{date}}',
      switch_plan: '切换计划',
      billing: {
        billing_cycle: '账单周期',
        next_billing_date: '下次账单日期',
        no_renewal: '无后续扣款',
        billing_suspended: '账单已暂停',
        auto_resume: '{{date}}（自动恢复）',
        pauses_on: '{{date}} 暂停',
        price: '价格',
        payment_method: '支付方式',
        update: '更新',
      },
      usage: {
        ai_generations_used: '已使用的 AI 生成次数',
        progress_label_ai: '已使用 {{limit}} 次中的 {{used}} 次 AI 生成',
        description_ai: '每个计费周期包含 {{limit}} 次 AI 生成。成功续订后额度重置，未使用的生成次数不会累积。',
        no_marketplace_downloads: '此方案不包含市场模型下载。',
        progress_label: '已下载 {{used}}/{{limit}} 个模型',
        paused_tooltip: '订阅暂停期间无法下载模型。恢复订阅后即可继续下载。',
        paused_tooltip_ai: '订阅暂停期间无法开始新的 AI 生成。恢复后即可继续生成。',
      },
      cancel_info: {
        no_generations: '取消后，您将无法开始新的 AI 生成',
        keep_license_ai: '您已生成的模型，在订阅有效期内完成的项目中仍保留授权',
        no_fee_no_commitment: '无取消费用 — CGTrader AI 没有合约期限，您可以随时取消',
        title: '如果我取消会怎样？',
        keep_access: '您将保留访问权限直到已付费期间结束',
        no_downloads: '取消后，您将无法下载新模型',
        keep_license: '您已下载的模型在订阅有效期内完成的项目中仍可继续使用',
        cancellation_fee: '如果您在前45天内取消，则不收取取消费用。超过此期限后，将收取您合同义务剩余余额50%的取消费用。',
        cancellation_fee_new_yearly: '取消订阅将产生剩余合同余额50%的提前取消费用。您将在该费用覆盖的期间内保留访问权限。',
      },
    },
    paused: {
      badge_paused: '已暂停',
      badge_scheduled: '已安排暂停',
      resume_button: '恢复订阅',
      cancel_scheduled_pause_button: '取消已安排的暂停',
    },
    pause_offer: {
      hero_amount: '$0',
      hero_caption: '暂停期间的费用',
      title: '休息一下 — 无需取消',
      description: '暂停将在您当前的订阅周期结束后开始。您可以随时恢复订阅，否则将在 1 个月后自动恢复。',
      benefits: {
        no_extra_charges: '无额外费用',
        downloads_licensed: '已下载内容的许可证仍然有效',
        resume_anytime: '随时恢复',
      },
      pause_button: '暂停我的订阅',
      continue_to_cancel: '继续取消',
    },
    pause_confirmation: {
      header: '已安排暂停',
      title: '您的订阅将暂停',
      description: '您将用完已付费的周期，然后订阅将于 {{date}} 暂停。暂停期间不会收费。您可以随时恢复 — 否则将在 1 个月后自动恢复。',
      description_no_date: '您将用完已付费的周期，然后订阅将暂停。暂停期间不会收费。您可以随时恢复 — 否则将在 1 个月后自动恢复。',
      done_button: '完成',
    },
    pause: {
      errors: {
        generic: '出现问题。请刷新页面并重试。',
        subscription_not_found: '未找到该订阅。请刷新页面。',
        subscription_cannot_be_paused: '该订阅目前无法暂停。请刷新页面。',
        subscription_pause_already_scheduled: '该订阅已安排暂停。请刷新页面。',
        subscription_billing_period_unavailable: '无法安排暂停。请稍后重试或联系客服。',
        subscription_pause_start_must_be_future: '您的续订正在处理中。请在完成后重试。',
        user_pause_allowance_exhausted: '您已用完该订阅的最长暂停时间。',
        subscription_cannot_be_resumed: '该订阅无法恢复。请刷新页面。',
        solidgate_request_failed: '我们的支付服务商出现错误。请刷新页面并重试。',
      },
    },
    billing_cycle: {
      yearly: '年度',
      monthly: '月度',
    },
    switch_plan_section: {
      price_unit: '/月',
      tags: {
        yearly: '节省 60%',
        monthly: '随时取消',
      },
    },
    switch_plan_modal: {
      title: '切换计划',
      cancel: '取消',
      current_plan: '当前计划',
      submit: {
        to_yearly: '切换到年度计划',
        to_monthly: '切换到月度计划',
      },
      notice: {
        yearly_to_monthly: '您的计划将在当前年度承诺结束时（{{date}}）切换为月度。在此之前无需任何操作。',
        monthly_to_yearly: '您的计划将立即切换为年度。今天开始一个新的 12 个月承诺。首次扣款后将适用提前取消费用。',
      },
      plan: {
        yearly: {
          name: '年度计划',
          subtitle: '按月扣款',
        },
        monthly: {
          name: '月度计划',
          subtitle: '无承诺',
        },
      },
      toast: {
        success: '您的套餐切换已安排。',
        error: '无法安排您的套餐切换。请重试。',
      },
      preview_toast_error: '无法加载套餐详情。请重试。',
    },
    cancel_modal: {
      no_fee_description_ai: '您的访问权限和剩余的 AI 生成次数将持续到 {{date}}。届时不会产生扣款。',
      title: '取消订阅',
      reason_label: '请告诉我们您取消的原因',
      reason_placeholder: '选择原因...',
      submit_button: '取消订阅',
      reasons: {
        generations_not_good_enough: '生成的模型质量不够好',
        no_longer_need: '我目前不再需要3D模型',
        short_term_project: '我只是为了短期项目需要',
        not_enough_models: '没有找到足够的相关模型',
        not_worth_price: '订阅不值这个价格',
        not_used_enough: '我使用不够多',
        prefer_individual: '我更喜欢单独购买模型',
        other: '其他',
      },
      other_label: '请说明',
      other_placeholder: '请告诉我们更多...',
      banner_description: '您的访问权限将保持到{{date}}。此日期之后不会再次收费。',
      loading_fee: '正在加载取消详情...',
      fee_error: '无法加载取消费用详情。请关闭后重试。',
      fee_title: '取消费用：{{fee}}',
      fee_description: '您的访问权限将保持到{{date}}。取消费用将从您的支付方式中扣除。',
      no_fee_description: '您的访问权限将保持到{{date}}。不会收取取消费用。',
      fee_title_header: '确认提前取消',
      fee_warning_banner: '取消将产生<strong>50%的提前取消费用</strong>。',
      consequences_title: '在您离开之前 — 取消后会发生以下情况',
      consequences: {
        no_generations: '取消后，您将无法开始新的 AI 生成。',
        keep_license_ai: '您已生成的模型，在订阅有效期内完成的项目中仍保留授权。',
        no_fee_no_commitment: '无取消费用 — CGTrader AI 没有合约期限，您可以随时取消。',
        keep_access: '您将保留访问权限直到已付费期间结束。',
        no_downloads: '取消后，您将无法下载新模型。',
        keep_license: '您已下载的模型在订阅有效期内完成的项目中仍可继续使用。',
        fee_notice: '如果您在前45天内取消，则不收取取消费用。超过此期限后，将收取您合同义务剩余余额50%的费用。',
        fee_notice_new_yearly: '取消订阅将产生剩余合同余额50%的提前取消费用。您将在该费用覆盖的期间内保留访问权限。',
      },
      remaining_months: '剩余月数',
      monthly_rate: '月费',
      total_remaining: '剩余总额',
      cancellation_fee_percent: '50%取消费用',
      calculated_active_period: '您的计算有效期',
      contract_commitment_value: '合同承诺金额：',
      cancellation_fee_summary: '取消费用（50%）：',
      acknowledge_checkbox: '我理解该费用并希望继续取消',
      keep_subscription_button: '保留订阅',
      back_button: '返回',
      continue_button: '继续取消',
      success: '您的订阅已成功取消。',
      error: '取消订阅失败。请重试。',
      confirmation: {
        title_ai: '取消已安排在 {{date}}',
        body_no_fee_ai: '您将保留访问权限和剩余的 AI 生成次数至 {{date}}。此后将无法开始新的 AI 生成，但您已生成的内容仍保留授权。未收取取消费用。',
        body_no_fee_no_date_ai: '当前周期结束后将无法开始新的 AI 生成，但您已生成的内容仍保留授权。未收取取消费用。',
        header: '订阅已取消',
        title: '您的订阅已取消',
        body_no_fee: '您可以继续使用至{{date}}。之后您将无法下载新模型，但您已下载的所有内容仍可继续使用。未收取任何取消费用。',
        body_no_fee_no_date: '当前订阅期结束后，您将无法下载新模型，但您已下载的所有内容仍可继续使用。未收取任何取消费用。',
        body_fee: '您可以继续使用至{{date}}。已收取50%的提前取消费用{{fee}}。您已下载的模型仍可继续使用。',
        done_button: '完成',
      },
    },
    retry_payment: {
      button: '重试付款',
      button_loading: '正在重试...',
      helper_text: '是否已解决银行的问题？无需更换银行卡即可重新扣款。',
      processing: {
        title: '付款重试中',
        description: '我们已收到您的请求。付款可能需要一些时间处理 - 完成后我们会通过邮件通知您。',
      },
      error: {
        default: '付款再次失败。请更新付款方式或稍后重试。',
      },
    },
    status_banners: {
      pause_scheduled: {
        title: '您的订阅将于 {{date}} 暂停。',
        description: '在当前周期结束前，您仍可正常使用。暂停后不会收费，您可以随时恢复。',
      },
      paused: {
        title: '您的订阅已暂停。',
        description: '暂停期间不会收费。您可以随时在此页面恢复订阅。',
        description_operational: '暂停期间不会收费。',
      },
      resume_requested: {
        title: '已请求恢复',
        description: '我们正在恢复您的订阅 — 这可能需要一点时间。请刷新页面查看最新状态。',
      },
      redemption: {
        title: '付款问题 \u2014 更新付款方式',
        description: '您上次的付款尝试失败。我们将自动重试，或者您可以更新付款方式立即重试。',
      },
      suspended: {
        title: '您的订阅已被暂停',
        description: '于{{date}}暂停。请',
        description_no_date: '请',
        contact_link: '联系',
        description_suffix: '客服获取帮助。',
      },
    },
    payment_history: {
      status: {
        failed: '失败',
      },
    },
  },
  subscription_item_page: {
    subscribe_cta: '订阅并省钱',
    upgrade_cta: '升级方案',
  },
  subscription_upgrade: {
    explainer: {
      prefix: '正在从 Essentials 升级。本期您已使用',
      used_of_limit: '{{used}}/{{limit}}',
      middle: '次下载，因此我们将未使用的',
      unused: '{{unused}} 次',
      suffix: '抵扣今日的费用。'
    },
    payment_method: {
      title: '支付方式',
      subtitle: '我们将使用您账户中已保存的卡 — 无需重新输入。',
      saved_badge: '已保存',
      use_different: '使用其他支付方式'
    },
    order_summary: {
      title: '订单摘要',
      plan_name: 'CGTrader Premium 订阅',
      plan_cadence: '年度计划，按月计费',
      billing_period: '1年',
      premium_price: 'Premium 小计',
      credit_label: 'Essentials 抵扣',
      credit_basis: '{{limit}} 次下载中有 {{unused}} 次未使用',
      vat_included: '增值税（已含）',
      vat_tooltip: '增值税（VAT），也称为销售税或商品及服务税（GST），是在销售时向最终买家征收并缴纳给买家所在国政府的税款。',
      amount_due_today: '今日应付金额',
      cta: '支付 {{amount}} 并升级',
      next_billing_note: '*下次扣费为 {{price}}/月',
      legal_agreement_prefix: '继续即表示我同意',
      legal_agreement_terms: '通用条款与条件',
      legal_agreement_privacy: '隐私政策',
      legal_agreement_connector: '以及',
    }
  },
  subscription_checkout: {
    title: '选择支付方式',
    subtitle: '使用 Apple Pay、Google Pay、PayPal 或信用卡安全支付。',
    divider_text: '或',
    credit_card_button: '使用信用卡/借记卡支付',
    terms: {
      title: '您正在订阅 CGTrader 服务的年度套餐。',
      body_start: '您同意每月支付 {{price}}，直到合同结束或取消订阅。付款将通过您选择的付款方式扣除。如需取消，请前往账户设置 → 订阅管理，或查看我们的<a href="https://www.cgtrader.com/pages/terms-and-conditions" target="_blank" class="cgt-legacy-link">取消政策</a>。',
      body_end: '请注意，年度计划有提前取消费用。',
      annual: {
        title: '年度订阅条款（按月计费）',
        body: '您正在订阅 CGTrader 的年度套餐。您同意每月支付 {{price}}/月外加适用税费，直到合同结束或取消。您可以随时取消。如果在前 45 天内取消，则无需支付提前取消费用。之后可能会收取费用。如需取消，请前往账户设置 → 订阅管理，或查看我们的<a href="https://www.cgtrader.com/pages/terms-and-conditions" target="_blank" rel="noreferrer" class="cgt-legacy-link">取消政策</a>。',
      },
      monthly: {
        title: '月度订阅条款',
        body: '您正在订阅 CGTrader 的月度套餐。您同意每月支付 {{price}}/月。可随时通过账户设置 → 订阅管理取消，无需支付任何费用。',
      },
    },
    plan_selector: {
      section_title: '选择套餐',
      names: {
        yearly: '年度套餐',
        monthly:        '月度套餐',
      },
      subtitles: {
        billed_monthly: '按月计费',
        no_commitment: '无需承诺',
      },
      badges: {
        save_60:        '节省 60%',
        cancel_anytime: '随时取消',
      },
      select_aria: '选择{{name}}',
    },
    update_title: '更新支付方式',
    update_subtitle: '安全地更新您的支付信息。',
    update_credit_card_button: '信用卡/借记卡',
    update_save_button: '保存',
    update_cancel_button: '取消',
    order_summary: {
      title: '订单摘要',
      item_context: {
        sub_label: '订阅后即可下载',
      },
      billing_period: '1年',
      price_unit: '/月',
      subtotal: '小计',
      vat_included: '增值税',
      vat_tooltip: '增值税（VAT），也称为销售税或商品及服务税（GST），是在销售时向最终买家征收并缴纳给买家所在国政府的税款。',
      amount_due_today: '订单总额',
      pay_button: '以 {{amount}} 订阅',
      pay_button_upgrade: '支付 {{amount}} 并升级',
      premium_renewal_note: 'Premium 立即解锁 – 之后从 {{date}} 起每月 {{price}}',
      legal_agreement_prefix: '继续即表示我同意',
      legal_agreement_terms: '通用条款与条件',
      legal_agreement_privacy: '隐私政策',
      legal_agreement_connector: '以及',
      plans: {
        yearly: {
          name:           'CGTrader Essentials 订阅 — 年度计划，按月计费',
          billing_period: '一年',
          price_unit:     '/月',
          features: {
            first:  '每月 25 个资源 — 下载模型或使用 AI 生成',
            second: '即时访问 {{modelCount}}+ 精选 3D 模型',
            third:  '免版税，无 AI',
          },
        },
        monthly: {
          name:           'CGTrader Essentials — 月度套餐',
          billing_period: '',
          price_unit:     '/月',
          features: {
            first:  '每月 25 个资源 — 下载模型或使用 AI 生成',
            second: '即时访问 {{modelCount}}+ 精选 3D 模型',
            third:  '免版税，无 AI',
          },
        },
      },
    },
    company: {
      toggle_label: 'Purchase as a company',
      info_banner: 'Make sure you filled and applied company details.',
      company_name: 'Company name',
      company_code: 'Company code',
      vatin: 'Company tax number',
      vatin_tooltip: 'If your company is registered for VAT/GST/Sales or equivalent tax, please make sure to enter your tax number for validation (in some cases you might be eligible for 0% tax rate).',
      country: 'Country',
      state: 'State / Province',
      zip_code: 'Zip code',
      city: 'City',
      street_address: 'Street address',
      apply_button: 'Apply',
      applying: 'Applying...',
      field_required: '此字段为必填项',
    },
    payment_success_processing: '正在处理付款，请稍候…',
    payment_retry_button: '重试',
    payment_success_toast: '支付信息已成功保存。',
    payment_error_toast: '支付失败。请重试。',
    intent_update_error: '无法更新您的订单。请重试。',
    email_step: {
      title: '输入您的电子邮件',
      subtitle: '以继续订阅',
      email_label: '电子邮件地址',
      email_placeholder: 'john@email.com',
      email_required: '电子邮件为必填项',
      email_invalid: '请输入有效的电子邮件地址',
      helper_text: '仅用于向您发送交易信息。',
      continue_button: '继续',
      login_link_prefix: '已有账户？',
      login_link: '登录',
      divider: '或',
    },
    captcha_step: {
      title: '快速安全验证',
      subtitle: '请完成以下验证以继续付款。',
      continue_button: '继续',
      incomplete: '请完成验证码以继续。',
      failed: '验证码验证失败，请重试。',
    },
    login_step: {
      info_title: '您似乎已有账户',
      info_subtitle: '请登录以继续',
      title: '欢迎回来',
      subtitle: '登录以完成您的订阅',
      email_label: '电子邮件',
      password_label: '密码',
      login_button: '登录并继续',
      forgot_password: '忘记密码？',
      hide_password: '隐藏密码',
      show_password: '显示密码',
    },
    guest_banner: {
      paying_as: '付款账户',
      not_you: '不是您？',
    },
    create_account: {
      notice_title: 'Payment successful - you are subscribed!',
      notice_body: 'Your {{plan}} subscription is now active. A confirmation has been sent to',
      notice_body_no_plan: 'Your subscription is now active. A confirmation has been sent to',
      title: 'One last step - create your account',
      subtitle: 'Set a password to log in, download your model, and manage your subscription.',
      email_label: 'Email',
      submit_button: 'Register and start downloading',
    },
  },
  my_subscriptions: {
    profile_header: {
      title: '订阅设置',
      description: '管理您在Essentials计划中的参与。',
      learn_more: '了解更多',
    },
    status_card: {
      title: 'CGTrader Essentials',
      badge_participating: '参与中',
      badge_not_participating: '未参与',
      description: 'Essentials订阅计划允许用户按月付费访问精选模型库。',
      participation_label: '参与状态：',
      participation_text: '所有符合条件的模型将被包含。模型不能单独选择。',
      revenue_share_label: '收益分成：',
      revenue_share_text: '收益根据您在月度收入池中的订阅下载总量占比计算。',
      manage_label: '随时管理参与：',
      manage_text: '更改将在您更新设置后不久生效。',
      join_title: 'CGTrader Essentials已包含在"最大化收益"计划中。',
      join_description: '获取订阅收入、收益分成和定制企业机会。',
      join_button: '加入"最大化我的收益"计划',
    },
    tabs: {
      eligible_models: '符合条件的模型',
      earnings: '收益',
    },
    eligible_models: {
      description_line1: '查看您所有有资格获得订阅收入的模型。',
      description_line2: '在您选择退出之前，您的模型将保持活跃状态并对订阅者可用。',
      column_models: '模型',
      column_publishing_date: '发布日期',
      column_opt_in_date: '订阅加入日期',
      empty_title: '没有可用的模型',
      empty_description: '您目前没有符合CGTrader Essentials条件的模型。',
    },
    join_modal: {
      title: 'CGTrader订阅',
      title_legacy: '加入"最大化收益"计划',
      participating_pill: '正在参与"最大化收益"计划',
      intro_heading: '启用"最大化收益"以开始',
      intro_body: '解锁旨在增加您长期收入的额外变现机会。本计划让您可以使用：',
      intro_programs_essentials_label: 'CGTrader Essentials和Premium',
      intro_programs_essentials_text: '— 通过每月订阅下载赚取收益',
      intro_programs_enterprise_label: '企业及定制交易',
      intro_programs_enterprise_text: '参与量身定制的B2B协议',
      intro_programs_revenue_label: '收益分成机会',
      intro_programs_revenue_text: '从战略性分销合作中获益',
      intro_programs_equity_label: '股权式合作',
      intro_programs_equity_text: '用所选模型换取股权',
      intro_programs_other_label: '其他替代性补偿方式',
      intro_programs_other_text: '随时可用',
      intro_inset_title: '加入后会发生什么',
      intro_inset_models: '您的合格模型将成为计划资源池的一部分',
      intro_inset_earnings: '您将获得基于订阅的收入',
      intro_inset_opportunities: '您可能被纳入企业及替代性补偿机会的考虑范围',
      section_what_title: '订阅如何运作',
      section_what_body: 'CGTrader为买家提供两种订阅等级：',
      section_what_tier_essentials_label: 'Essentials',
      section_what_tier_essentials_text: '— 每月9.99美元，25次下载。日常素材。',
      section_what_tier_premium_label: 'Premium',
      section_what_tier_premium_text: '— 每月34.99美元，25次下载。高端素材。',
      section_what_tiers_note: '您的模型会被纳入与其类别相符的等级。一个模型可能出现在其中一个等级或两个等级中。未使用的下载不会结转。',
      section_earnings_title: '您的收入如何计算',
      section_earnings_body: '每个月，CGTrader根据您的模型下载次数占该月所有订阅下载总次数的比例，分配相应的订阅收入份额。',
      section_earnings_rule: '适用一条规则：每次下载的收入不超过您模型的标价乘以您的版税率 - 如果您的模型定价为5美元，则每次下载最多可赚取5美元乘以您的版税率。',
      section_earnings_timing: '收入在次月1日计算，且永不追溯调整。',
      section_refunds_title: '退款和拒付',
      section_refunds_body: '如果订阅者获得退款，该付款将从退款发生月份的收入池中移除，而非原始下载月份。实际上，退款很少发生，不会对您的收入产生实质性影响。',
      section_optin_title: '加入和退出',
      section_optin_body: '启用"最大化收益"（我的销售 → 折扣）后，模型将被添加到订阅目录。要移除您的模型，请禁用该设置。过去的收入不受影响。',
      join_cta: '加入"最大化收益"',
      description: '解锁更多变现机会，旨在增加您的长期收入。此计划为您提供以下访问权限：',
      benefit_essentials_label: 'CGTrader Essentials',
      benefit_essentials_text: '– 通过每月订阅下载获得收入',
      benefit_enterprise_label: '企业和定制交易',
      benefit_enterprise_text: '– 参与量身定制的B2B协议',
      benefit_revenue_label: '收益分成机会',
      benefit_revenue_text: '– 从战略分销合作中获益',
      benefit_equity_label: '基于股权的合作',
      benefit_equity_text: '– 用精选模型换取股权参与',
      benefit_other_label: '其他替代补偿模式',
      benefit_other_text: '在可用时提供',
      info_box_title: '加入后会发生什么：',
      info_box_essentials_name: 'CGTrader Essentials',
      info_box_essentials_suffix: '已完全包含在此计划中：',
      info_box_models: '您的合格模型将成为计划池的一部分',
      info_box_earnings: '您将获得基于订阅的收入',
      info_box_enterprise: '您可能会被考虑参与企业和替代补偿机会',
      confirm_button: '加入计划',
      cancel_button: '取消',
      got_it_button: '知道了',
      success: '您已成功加入"最大化收益"计划',
      error: '出了点问题，请重试。',
    },
  },
  publisher: {
    tooltips: {
      tags:
        '前 4 到 6 个标签对搜索最为重要。请先描述主要对象，再添加细节。',
      adult_content:
        '所有包含裸露或暴力内容的模型在发布前都会由 CGTrader 在 1–3 个工作日内完成审核。CGTrader 使用 RSAC 标准来评估内容。0 级内容对所有用户开放。被评定为 1-2 级的模型可以在设置年龄限制后发布。被评定为 3-4 级的模型不获批准在商城发布。',
    },
  },
  skills:{
    '3d-modeling': '3D Modeling',
    '3d-print-modeling': '3D Print Modeling',
    '3d-scanning': '3D Scanning',
    'animating': 'Animating',
    'grooming': 'Grooming',
    'lighting': 'Lighting',
    'low-poly-modeling': 'Low-poly Modeling',
    'particles': 'Particles',
    'pbr-modeling': 'PBR Modeling',
    'post-production': 'Post Production',
    'rendering': 'Rendering',
    'rigging': 'Rigging',
    'shaders': 'Shaders',
    'skinning': 'Skinning',
    'texturing': 'Texturing',
    'uv-mapping': 'UV mapping'
  },
  profilePage: {
    listings: '3D模型',
    reviews: '评价',
    imageGallery: '图片库',
    tutorials: '教程',
    rating: '评分',
    reputation: '声誉',
    responseRate: '回复率',
    responseTime: '回复时间',
    projectsDone: '完成的3D项目',
    modelViews: '模型浏览量',
    modelLikes: '模型点赞数',
    followers: '关注者',
    software: '3D软件',
    skill: '技能',
    about: '关于',
    modelos: '3D模型',
    projects: '3D项目',
    reviewsGiven: '发布的评价',
    ratings: '评分',
    positive: '积极',
    negative: '消极',
    priceLabel: '价格',
    positiveFirst: '积极优先',
    negativeFirst: '消极优先',
    tooltipTextResponseRate: '用户已回复消息的百分比',
    tooltipTextResponseTime: '用户回复消息的平均时间',
    tooltipTextProjectsDone: '成功完成的3D项目数量。目前正在进行{{projectCount}}个3D项目',
    tooltipTextModelViews: '设计师模型被查看的次数',
    tooltipTextModelLikes: '设计师模型收到的点赞数',
    tooltipTextFollowers: '设计师的关注者数量',
    noModelsUploaded: '用户尚未上传任何3D模型。',
    noModelsReviews: '暂无3D模型评价。',
    noProjectsReviews: '暂无3D项目评价。',
    loadMore: '加载更多',
    noArtworksUploaded: '用户尚未上传任何艺术作品。',
    noTutorialsUploaded: '用户尚未发布任何教程。',
    seeAllModels: '查看全部{{modelCount}}个3D模型',
    viewAllModels: '查看全部{{modelCount}}个模型'
  },
  navigation: {
    'aria': {
      'open_menu': '打开菜单',
      'close_menu': '关闭菜单',
      'search': '搜索',
      'search_by_image': '以图搜索',
      'cart': '购物车',
      'messages': '消息',
      'notifications': '通知',
      'account': '账户',
      'logo': 'CGTrader - 3D模型 / 3D设计师',
    },
    navbar: {
      'actions': {
        'new': '最新',
        'trending': '热门',
        'top_selling': '畅销',
      },
      'budgets': {
        'below_10': '低于$10',
        'up_to_10': '最多$10',
        'more_than_20': '超过$20',
        'more_than_50': '超过$50',
        'free': '免费',
        'sale': '促销中',
      },
      '3d_models': {
        'categories': '类别',
        'types': '类型',
        'budget': '预算',
        'all_models': '所有模型',
        'browse_all': '所有3D模型',
        'browse_all_print': '所有3D打印模型',
        'about': '关于3D模型',
        'about_print': '关于3D打印',
      },
      'community': {
        'title': '社区',
        'earn': '赚取',
        'upload_3d_model': '上传3D模型',
        'search_for_projects': '搜索项目',
      },
      'grow_your_sales': {
        'title': '增加您的销售额',
        'sell_more': '卖出更多 🚀',
        '3d_market_insights': '3D市场洞察',
        'top_model_searches': '热门3D模型搜索',
        'top_print_searches': '热门3D打印搜索',
      },
    },
    'search': {
      placeholder: '在超过200万个模型中搜索',
    },
    'user': {
      login: '登录',
      register: '注册',
    },
    'projects': {
      seller_perspective: '自由3D项目',
      browse: '浏览项目',
      start: '开始项目',
      about: '关于3D项目',
      work: '与CGTrader工作',
      my_projects: '我的项目',
      buyer_perspective: '聘请设计师3D',
    },
    '3d-models': {
      'title': '3D模型',
      '3d-printing': '3D打印',
      'pbr': '基于物理渲染',
      'vr_low-poly': '虚拟现实 /低多边形',
      'scanned_3d-models': '扫描的3D模型',
      'find_designers': '寻找最好的设计师',
      'discounts': '折扣',
      'scripts_apps': '脚本和应用',
      'textures': '纹理',
      'show-all': '显示所有',
      'free': '免费的3D模型',
    },
    'sell_3d-models': '出售3D模型',
    'enterprise': {
      title: '3D内容制作',
      management: '3D资产管理',
    },
    'credits_guest_widget': {
      'get': '并获得高达 ',
      'create': '现在创建帐户！',
      'learn_more': '了解更多关于CGTrader忠诚学分 ',
      'link': '这里',
      'text_below_1': '积分可以在购买时“使用',
      'text_below_2': '“签署标志着模式和覆盖到价格的30％折扣。',
      'sign-up': '注册',
      'discount': ' 折扣',
      'for': '为您',
      'purchase': '第一次购买！',
    },
    'tooltips': {
      discounts: 'CGTrader忠诚折扣',
      cart: '购物车',
      conversations: '我的对话',
      notifications: '通知',
      publisher: '出版者',
    },
    'cart_widget': {
      'wishlist_tab': '心愿单',
      'recently_viewed_tab': '最近查看',
      'potential_discount': '潜在折扣：',
      'discount_applied': '已应用折扣：',
      'sale_tooltip': '我们促销活动的折扣仅在您的购物车达到 ${{threshold}} 或以上时才会应用。',
      'left_to_unlock_discounts': '还差 {{leftToUnlock}} 即可解锁折扣',
      'continue_shopping': '继续购物',
      'wishlist_empty_title': '您的心愿单是空的',
      'wishlist_empty_text': '开始探索并收藏您喜欢的商品 — 它们会显示在这里。',
      'recently_viewed_empty_title': '这里还没有内容',
      'recently_viewed_empty_text': '开始探索，您最近查看的商品会显示在这里。',
      'sale_tooltip_text': '此商品正在促销，但只有当您的购物车小计达到 ${{threshold}} 或以上时才会应用折扣。',
      title: '购物车',
      subtitle: '购物车是空的',
      text: '开始探索并用精彩发现填满您的购物车！',
      have: '你有',
      items: ' 在您的购物车中的商品。',
      total: '总：',
      remainer: '要激活CGTrader积分，请添加：',
      used: '积分使用：',
      discount: '用优惠券的企业：',
      sale_discounts: '折扣应用：',
      sale_time_left: '剩余时间',
      final: '最终价格：',
      proceed: '进行结算',
      view: ' 查看购物车',
    },
    'community': {
      'title': '社区',
      'galleries': '画廊',
      'tutorials': '教程',
      'forum': '论坛',
      'designers': '设计师',
      'challenges': '挑战',
      'digital_art': '数字艺术大赛',
      'blog': '博客',
      'community_ratings': '社区评级',
      'sell_3d-models': '出售3D模型',
      'printlist': '3D的printList',
      'invite': '邀请朋友',
    },
    'credits_user_widget': {
      title: 'CGTrader忠诚折扣',
      par_1: '你有',
      par_2: ' CGTrader学分。',
      par_2_variation: ' 在没有促销活动时您可以花费的积分。',
      notice:
        '注意：CGTrader积分在促销期间无法使用，但促销结束后将重新可用。与此同时，查看3D模型的超值优惠<a href="https://www.cgtrader.com/3d-models?sale_off=1">这里</a>。',
      first_text_1:
        '认为这是一个礼物送给你的第一次购买 - 你可以使用积分购买时“',
      first_text_2:
        ' “标模型，并得到了它的价格的30％的优惠。如果你的车的总价值等于或高于$ 的更大的学分才能使用。',
      regular_text_1: '积分可以在购买时“使用',
      regular_text_2: ' “签署标志着模型和掩盖它的价格的30％折扣。',
      important: '重要：',
      message:
        ' 积分不能在销售活动中使用，但你仍然可以增加你的提成水平，并收集更多学分您下次购买。',
      more_credits: '如何获得更多的积分？',
      list_item: '通过对CGTrader增加你一生的消费，你的信用赚取率也增加。',
      learn_more: '学到更多',
      earn_rate: '信用赚取率',
      lifetime_spending: '终身支出：',
      next_level: '下一级：',
      condition_1:
        'CGTrader积分可用于购买标有<i class="custom-font-icon custom-font-icon--small icon-wallet"></i>标志的模型，可享受高达30%的折扣。',
      condition_2:
        '积分只能在购物车总价值达到<strong>${{minimum}}</strong>或以上时使用。',
      condition_3: '在促销活动或特价销售期间，积分无法使用。',
      condition_4:
        '请注意，积分有有效期 - 您的积分将在<strong>{{days}}</strong>天后过期。',
    },
    'item_add_message': '已成功添加到购物车',
    'already_added_message': '已经被添加到购物车',
    'conversations_widget': {
      messages: {
        loading: '加载收件箱',
      },
      conversations: '对话',
      types: {
        personal: '个人消息',
        offer: '报价',
        cgtrader_support: 'CGTrader支持',
        model_support: '模型的支持',
        job_application: '三维工程',
        file_conversion_request: '文件转换请求',
        model_feedback: '产品反馈',
        promotions: '促销',
      },
    },
    'user_menu': {
      gdpr_notice: {
        message: '您需要查看您的{{link}}',
        link: '电子邮件通知偏好设置',
      },
      dashboard: '管理仪表板',
      settings: '账户设置',
      public_profile: '公开资料',
      logout: '退出',
      seller: {
        publishing: '上传3D模型',
        models: '我的模型',
        sales: '我的销售',
        subscription: '订阅',
        analytics: 'Analytics（分析）',
        freelance: '我的3D项目',
        wishlist: '三维模型的收藏',
        freelance_cgtrader: '自由与CGTrader',
        publish_project: '发布项目',
        find_new_projects: '寻找新的3D项目',
      },
      buyer: {
        purchases: '我的采购',
        wishlist: '三维模型的收藏',
        freelancers: '寻找自由职业者',
        sell: '出售3D模型',
      },
    },
    'already_purchased_message': '您已经购买此产品。',
    'cart_limit_reached':
      '您的购物车已达到500件商品的限制。要继续购物，请完成当前订单，然后为其他商品开始新订单。',
  },
  'sale_off_bar': {
    'find_deals': '寻找优惠',
  },
  'subscribe_bar': {
    'content_full': '每月 25 个模型，{{price}} 起',
    'content_short': '每月 25 个模型，{{price}} 起',
    'cta': '获取订阅',
  },
  'cgdream_notice_bar': {
    'message': '来自 CGDream？图像生成功能现已迁移至 CGTrader AI。',
    'dismiss': '关闭通知',
  },
  footer: {
    'subscribe': {
      'header': '订阅我们的新闻：',
      'button-active': '订阅',
      'button-disabled': '已订阅',
      'text': '通过订阅您确认您已经阅读并接受我们的',
      'terms-link': '使用条款',
      'placeholder': '输入您的电子邮箱',
    },
    'links': {
      companyLinks: [
        {
          text: '公司',
          link: '/discover/about-us',
        },
        {
          text: '博客',
          link: '/blog',
        },
        {
          text: '职业',
          link: '/pages/careers',
        },
        {
          text: '帮助中心',
          link: 'https://help.cgtrader.com',
        },
      ],
      buyLinks: [
        {
          text: '购买3D模型',
          link: '/zh-cn/3d-models',
        },
        {
          text: '企业版',
          link: '/discover/business-account',
        },
        {
          text: '3D数据集',
          link: '/discover/datasets',
        },
        {
          text: '聘请3D设计师',
          link: '/3d-modeling-jobs',
        },
        {
          text: '免费3D模型',
          link: '/zh-cn/free-3d-models',
        },
        {
          text: '免费3D打印模型',
          link: '/zh-cn/free-3d-print-models',
        },
      ],
      sellLinks: [
        {
          text: '出售3D模型',
          link: '/discover/sell-3d-models',
        },
        {
          text: '提升销量',
          link: '/discover/sell-more',
        },
        {
          text: '3D市场洞察',
          link: '/discover/3d-market-trends',
        },
        {
          text: '热门3D模型搜索',
          link: '/discover/3d-models-top-searches',
        },
        {
          text: '热门3D打印搜索',
          link: '/discover/3d-print-models-top-searches',
        },
      ],
      communityLinks: [
        {
          text: '社区',
          link: '',
        },
        {
          text: '优秀设计师',
          link: '/designers',
        },
        {
          text: '挑战赛',
          link: '/challenges',
        },
        {
          text: '论坛',
          link: '/forum',
        },
      ],
      // enterpriseLinks: [
      //   {
      //     text: 'Modelry',
      //     link: 'https://www.modelry.ai/?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=modelry&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: '3D浏览器',
      //     link: 'https://www.modelry.ai/3d-viewer?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_viewer&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: '3D产品可视化',
      //     link: 'https://www.modelry.ai/3d-product-visualization?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_product_visualization&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: '3D数字资产管理',
      //     link: 'https://www.modelry.ai/3d-digital-asset-management?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_digital_asset_management&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: '自定义三维建模',
      //     link: 'https://www.modelry.ai/how-to-order-custom-3d-models?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=3d_content_production&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      //   {
      //     text: '虚拟摄影',
      //     link: 'https://www.modelry.ai/virtual-photography?utm_source=cgtrader_marketplace&utm_medium=referral&utm_campaign=marketplace_shop&utm_id=00001&utm_term=2210&utm_content=virtual_photography&utm_creative_format=footer_menu&utm_marketing_tactic=marketplace_users&utm_source_platform=cgtrader',
      //   },
      // ],
      // aiImageGeneratorLinks: [
      //   {
      //     text: 'CGDream | AI图像生成器',
      //     link: 'https://cgdream.ai/',
      //   },
      //   {
      //     text: '使用Flux Dev生成图像',
      //     link: 'https://cgdream.ai/features/free-flux-ai-image-generator',
      //   },
      //   {
      //     text: '文本转图像AI',
      //     link: 'https://cgdream.ai/features/text-to-image-ai-generator',
      //   },
      //   {
      //     text: 'AI照片编辑器',
      //     link: 'https://cgdream.ai/features/ai-photo-editor',
      //   },
      //   {
      //     text: 'AI 3D渲染',
      //     link: 'https://cgdream.ai/features/ai-3d-rendering',
      //   },
      //   {
      //     text: 'AI 3D模型生成器',
      //     link: 'https://cgdream.ai/features/ai-3d-model-generator-image-to-3d',
      //   },
      //   {
      //     text: '图像AI滤镜',
      //     link: 'https://cgdream.ai/features/ai-filters-for-images',
      //   },
      //   {
      //     text: 'AI图像放大器',
      //     link: 'https://cgdream.ai/features/ai-image-upscaler',
      //   },
      //   {
      //     text: 'AI图像修复',
      //     link: 'https://cgdream.ai/features/ai-image-inpainting',
      //   },
      // ],
    },
    'bottom-row': {
      'terms-link': '条款和条件',
      'privacy': '隐私',
    },
  },
  profile: {
    model_uploader: {
      file_not_finalized_tooltip: '此文件尚未完成上传，将不会发布。请删除它并重新上传。',
      file_not_finalized_sr: '文件尚未完成上传，将不会发布。',
    },
    my_models: {
      pack_creation: {
        flash_error: '出现问题，请重试',
        load_error: '无法加载所选模型。一次选择的模型过多时可能会发生这种情况。请重试或减少所选模型的数量。',
        retry: '重试',
      },
      image_restore: {
        body_default: '您的部分模型预览可能因近期的存储问题而受到影响。如果您的任何图片显示异常，请点击"恢复图片"，我们将在您的所有模型中重新检查并修复这些图片。',
        title_pending: '正在恢复您的预览',
        body_pending: '您的请求已提交，我们正在重新检查每个模型。此过程在后台运行，最长可能需要 3 天，因此您无需保持此页面打开。完成后，我们会在此处并通过电子邮件通知您。',
        title_finished: '恢复完成',
        body_finished: '我们已重新检查您的所有模型并尽可能恢复了图片。如果缩略图仍显示"无预览"，则表示该图片无法恢复，您可以重新上传。',
        button_restore: '恢复图片',
        button_requested: '已请求恢复',
        helper_within_3_days: '预览将在 3 天内更新。',
      },
      errors: {
        load_failed: '无法加载您的模型。请刷新页面后重试。',
      },
    },
    my_sales: {
      earnings_detail: {
        generate_report: '生成报告',
        report_sent_confirmation: '报告将很快发送到您的邮箱！',
        errors: {
          sales_load_failed: '无法加载销售收益。',
          downloads_load_failed: '无法加载下载收益。',
          subscription_earnings_load_failed: '无法加载订阅收益。',
        },
      },
      leave_program_modal: {
        header: '退出收益最大化计划',
        primary_action: '退出收益最大化计划',
        cancel: '取消',
        description: '您确定要停止参与收益最大化计划吗？',
        bullet_models: '所有模型将不再参与订阅收益',
        bullet_promotion: '您将不会被包含在企业、收入分成、股权或替代补偿交易中',
        bullet_revenue: '您将继续从标准市场销售中获得收入',
        warning_title: '重要提示：月收入逻辑',
        warning_active_deals: '参与状态在每月1日00:00进行快照记录',
        warning_pending_payouts: '如果您在月中退出，当月收益不会受到影响',
        warning_re_enroll: '更改从下一个月度周期开始生效',
        warning_historical_data: '收入池根据该月的实际下载量按月计算',
        info_line: '您当月的收益是安全的，将按照标准付款时间表支付。',
      },
    },
  },
  items: {
    last_card: {
      text: '找不到你在寻找什么？',
      button_text: '要求自订的3D模型',
    },
  },
  model: {
    download_limit_exceeded: '您已超出每日下载限制。请明天再试。此限制不适用于过去12个月内有购买记录的用户。',
    subscription: {
      limit_reached_detailed: '您已达到本月{{limit}}次下载上限。您的限制将于{{reset_date}}重置。如需立即下载更多模型，您可以单独购买。',
      limit_reached_detailed_no_date: '您已达到本月{{limit}}次下载上限。如需立即下载更多模型，您可以单独购买。',
    },
  },
  search_page: {
    seo_area: {
      by_relevance: '按相关性：',
      by_extension: '按扩展名：',
      by_style: '按风格：',
      by_type: '按类型：',
    },
    results: {
      empty_title: '未找到模型',
      empty_description: '请尝试更改或移除部分筛选条件。',
      clear_filters: '清除筛选条件',
      search_all_types: '搜索所有类型',
      error: '加载结果时出错，请重试。',
      pagination: '搜索结果页面',
      showing: '显示第 {{start}}-{{end}} 项，共 {{total}} 项',
      per_page: '每页',
      first_page: '转到第一页',
      previous_page: '转到上一页',
      next_page: '转到下一页',
      last_page: '转到最后一页',
      page_input: '跳转到页面',
      results_count: '{{total}} 个结果',
      models_count: '{{total}} 个模型',
    },
    filters: {
      poly_count: {
        title: '面数',
        title_with_count: '面数 ({{count}})',
        low_poly_label: 'Low-poly',
        low_poly_value: '最多20k',
        mid_poly_label: 'Mid-poly',
        mid_poly_value: '20k - 100k',
        high_poly_label: 'High-poly',
        high_poly_value: '100k - 1M+',
        reset: '重置',
        checkboxes_group_label: '多边形范围选项',
        info_tooltip: '面数是构成3D模型的多边形总数。\n\nLow-poly：最多20k——非常适合实时使用（游戏、移动端、AR/VR）。\nMid-poly：20k – 100k——适合大多数生产用途。\nHigh-poly：100k – 1M+——最适合渲染、影视和产品可视化。',
      },
      style: {
        title: '风格',
        title_with_count: '风格 ({{count}})',
        find_placeholder: '搜索风格...',
        no_matches: '无匹配',
        reset: '重置',
        tags_group_label: '风格选项',
        show_more: '显示更多',
        show_less: '显示更少',
        groups: {
          era: '时代',
          genre: '类型',
          rendering: '渲染',
          look: '外观',
          surface: '表面',
          purpose: '用途',
          form: '形态',
          subject: '主题',
        },
      },
      features: {
        title: '特性',
        title_with_count: '特性 ({{count}})',
        search_placeholder: '查找特性...',
        no_matches: '无匹配',
        reset: '重置',
        game_ready: '游戏就绪',
        with_renders: '含渲染图',
        simulation_ready: '仿真就绪',
        show_more: '显示更多',
        show_less: '显示更少',
      },
      size: {
        title: '尺寸',
        unit: '单位',
        units: {
          cm: '厘米 (cm)',
          in: '英寸 (in)',
          mm: '毫米 (mm)',
        },
        whole_print_size: '整体打印尺寸',
        largest_print_size: '最大打印尺寸',
        width: '宽度 (X)',
        depth: '深度 (Y)',
        height: '高度 (Z)',
        quick_select: '快速选择',
        presets: {
          under_5: '< 5 cm',
          range_5_15: '5 - 15 cm',
          range_15_30: '15 - 30 cm',
          range_30_50: '30 - 50 cm',
          range_50_100: '50 - 100 cm',
          over_100: '100 cm +',
        },
        reset: '重置',
      },
      categories: {
        title: '类别',
      },
      date_published: {
        title: '发布日期',
        all_time: '全部时间',
        last_24_hours: '过去24小时',
        last_7_days: '过去7天',
        last_30_days: '过去30天',
        last_6_months: '过去6个月',
        last_12_months: '过去12个月',
        custom: '手动选择日期',
        start_date: '开始日期',
        end_date: '结束日期',
        previous_month: '上个月',
        next_month: '下个月',
        cancel: '取消',
        apply: '应用',
      },
      designers: {
        title: '设计师',
        search_placeholder: '查找设计师...',
        following: '已关注',
        following_indicator: '已关注',
        top: '顶级设计师',
        models_count: '（{{count}} 个模型）',
        loading: '正在加载设计师...',
        searching: '正在搜索设计师...',
        no_results: '未找到设计师。',
        no_following: '您还没有关注任何设计师',
        show_more: '显示更多',
      },
      advanced: {
        title: '高级筛选',
        general_group_label: '常规',
        my_library_group_label: '我的资料库',
        packs: '模型包',
        has_marmoset: '3D 查看器',
        has_video: '有视频',
        cgt_standard: 'CGT Standard',
        all_models: '全部模型',
        wish_list_only: '仅心愿单',
        liked_models_only: '仅点赞的模型',
        purchased_items_only: '仅已购商品',
      },
      file_format: {
        title: '文件格式',
        search_placeholder: '输入搜索...',
        show_more: '显示更多',
        show_less: '显示更少',
      },
      price: {
        title: '价格',
        on_sale: '折扣商品',
        with_subscription: '订阅商品',
        subscription_all: '全部',
        your_plan: '您的方案',
        min_price: '最低价格',
        max_price: '最高价格',
        ranges: {
          free: '免费',
          range_2_10: '$2 - $10',
          range_10_20: '$10 - $20',
          range_20_50: '$20 - $50',
          range_50_100: '$50 - $100',
          more_than_100: '$100+',
        },
      },
      license: {
        title: '许可证',
        group_label: '许可',
        ai_usage_group_label: 'AI 使用',
        all: '所有许可',
        royalty_free: '免版税',
        editorial: '编辑用途',
        custom: '自定义',
        ai_usage_allowed: '允许 AI 使用',
      },
      quality: {
        title: '质量',
        content_source_title: '内容来源',
        tooltip: 'Basic – 几何体和材质较为简单的入门级资源。\nPremium – 拓扑干净、材质细致的高保真资源。\nPro – 按专业和生产标准制作的顶级资源。\n\nAI生成 – 仅显示使用 AI 工具创建的资源。\n人工创作 – 仅显示由人工设计师创建的资源。',
        levels: {
          any: '任意',
          basic: 'Basic',
          premium: 'Premium',
          pro: 'Pro',
        },
        content_source: {
          all: '所有内容',
          ai_generated: 'AI生成',
          human_created: '人工创作',
        },
      },
      more_filters: {
        trigger_label: '筛选',
        trigger_label_with_count: '筛选 ({{count}})',
        desktop_title: '更多筛选',
        modal_title: '所有筛选',
        close_label: '关闭筛选',
        reset: '重置',
        apply_filters: '应用筛选',
      },
      asset_type: {
        group_label: '资源类型',
        all: '全部',
        three_d_only: '仅 3D',
        three_d_only_short: '3D',
        three_d_print_only: '仅 3D 打印',
        three_d_print_only_short: '3D 打印',
      },
      clear_all: '清除所有筛选条件',
      clear_all_short: '清除 ({{count}})',
      sorting: {
        title: '排序',
        trending: '热门',
        top_sellers: '畅销',
        reset: '重置',
        best_match: '最佳匹配',
        default_option: '默认',
        newest: '最新',
        oldest: '最早',
        lower_price: '价格从低到高',
        higher_price: '价格从高到低',
      },
      secondary: {
        group_label: '次级筛选',
        search_placeholder: '在结果中搜索...',
      },
      search_within: {
        button_label: '在结果中搜索',
        selected_group_label: '已选词条',
        remove_term: '移除{{term}}',
        related_searches: '相关搜索',
      },
      technical_attributes: {
        group_label: '技术属性',
        animated: '动画',
        rigged: '已绑定',
        low_poly: '低多边形',
        pbr: 'PBR',
        simulation_ready: '仿真就绪',
      },
      print_attributes: {
        group_label: '打印属性',
        with_makes: '含 Makes',
        three_d_print_verified: '3D 打印已验证',
        pre_supported: '已加支撑',
        multiple_parts: '多部件',
        simulation_ready: '仿真就绪',
      },
      tags: {
        title: '标签建议',
        more: '更多',
        title_with_count: '标签建议 ({{count}})',
        tags_group_label: '标签建议',
        find_placeholder: '搜索类别...',
        no_matches: '无匹配',
        show_more: '显示更多',
        show_less: '显示更少',
        reset: '重置',
      },
    },
  },
}
// jshint ignore: end
